<app-image-section-head [title]="title" [description]="description" [image]="image"></app-image-section-head>

<main id="main-content" class="container">

    <div class="row mb-4">
        <div class="col-12">
            <div class="card-blue">
                <div class="row mb-3">
                    <div class="col-md-8 col-xl-9">
                        <p i18n>Comprueba la matricula de un vehiculo para saber su distintivo ambiental</p>
                    </div>
                    <div class="col-md-4 col-xl-3 text-center">
                        <img src="assets/images/IMG_etiquetes-09.png" alt="etiqueta ambiental"
                            class="labels-img clickable">
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-8  col-xl-9 matricula">
                        <img src="assets/images/matricula.png" alt="matricula">
                        <input type="text" class="form-control" placeholder="0000AAA" aria-label="plate"
                            aria-describedby="plate" [(ngModel)]="plate" (keyup.enter)="checkPlate()"
                            (input)="onInputChange($event)">
                    </div>
                    <div class="col-md-4 col-xl-3 text-center">
                        <button type="button" class="btn btn-primary btn-rounded" (click)="checkPlate()"
                            *ngIf="!plateResponse" i18n>Consulta el distintivo</button>
                        <button type="button" class="btn btn-primary btn-rounded" (click)="resetPlate()"
                            *ngIf="plateResponse" i18n>Nueva consulta</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-5" *ngIf="plateResponse">
        <div class="col-12 plate-data" *ngIf="plateResponse.label!='-'">
            <div class="row">
                <div class="col-md-4">
                    <img [src]="'data:image/svg+xml;base64,'+ plateResponse.iconLabel" class="label-img"
                        alt="etiqueta ambiental" />
                </div>
                <div class="col-md-8">
                    <div class="row">
                        <div class="col-12">
                            <p>{{plateResponse.labelDescription}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12" *ngIf="plateResponse.label=='-'">
            <div class="no-label-box">
                <p>{{plateResponse.labelDescription}}</p>
                <p i18n>Si tu vehículo no tiene etiqueta, está afectado, date de alta para pedir autorizaciones de acceso o
                    bien para consultar si has llegado al límite de accesos diarios permitidos (de acuerdo a las ordenanzas
                    municipales).</p>
                <button class="btn btn-primary" (click)="goLogin()" i18n>Date de alta</button>
            </div>
        </div>
    </div>
</main>

<section class="container-fluid pb-5" role="region" aria-label="Etiquetas Ambientales">
    <div class="container">
        <div class="row">
            <div class="col">

                <h2 class="my-4"><strong i18n>Etiquetas Ambientales</strong></h2>
                <p>{{texto_descripcion}}</p>
                <div class="accordion secondary" id="accordionTags">
                    <div *ngFor="let l of labels; let i = index" class="accordion-item">
                        <h3 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                [attr.data-bs-target]="'#collapse-' + i" aria-expanded="false"
                                [attr.aria-controls]="'collapse-' + i">{{l.code}}</button>
                        </h3>
                        <div id="collapse-{{i}}" class="accordion-collapse collapse" data-bs-parent="#accordionTags">
                            <div class="row" *ngIf="l.image">
                                <div class="col-md-4">
                                    <img [src]="'data:image/png;base64,'+ l.image" alt="etiqueta ambiental" />
                                </div>
                                <div class="col-md-8">
                                    <div class="accordion-body" [innerHTML]="l.description"></div>
                                </div>
                            </div>
                            <div class="row" *ngIf="!l.image">
                                <div class="col">
                                    <div class="accordion-body" [innerHTML]="l.description"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- <div class="container mb-5">
    <div class="row">
        <div class="col">
            <h3 class="my-4" i18n>Categorías de vehículos:</h3>
            <div class="card accordion secondary" id="accordionCats">
                <div *ngFor="let c of categories; let i = index" class="accordion-item">
                    <h3 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            [attr.data-bs-target]="'#collapseC-' + i" aria-expanded="false"
                            [attr.aria-controls]="'collapseC-' + i" [innerHTML]="c.code"></button>
                    </h3>
                    <div id="collapseC-{{i}}" class="accordion-collapse collapse" data-bs-parent="#accordionCats">
                        <div class="row">
                            <div class="col">
                                <div class="accordion-body" [innerHTML]="c.description"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->